import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import { IconButton, Paper, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { EnhancedEncryption, Key } from '@mui/icons-material';
import PapeisPanel from './PapeisPanel';
import RedminePanel from './RedminePanel';
import ChavesPanel from './ChavesPanel';
import ThemeSetting from './ThemeSetting';
export const IB = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
}));
export default function SettingPanel() {
    const [open, setOpen] = React.useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const arr = location.pathname.split('/')
console.log( arr);
    const [tela, setTela] = React.useState(arr.length <3?'home':arr[arr.length-1]);
    const [showDraw, setShowDraw] = React.useState(arr.length <3);
    console.log( location.pathname );

    React.useEffect(()=>{
        window.history.replaceState(null, '', '/setting/'+tela);
    },[tela])

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const DrawerList = (
        <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
            <List>
                <ListItem disablePadding>
                    <ListItemButton onClick={() => setTela("theme")}>
                        <ListItemIcon>
                            <svg fill="#000000" width="32px" height="32px" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M17.5 15c-.797 0-1.456.314-1.88.793-.424.48-.62 1.098-.62 1.707 0 .78-.568 1.418-.81 1.607-.372.294-.165.892.31.893H17c.786 0 1.517-.23 2.072-.662.555-.432.928-1.09.928-1.838 0-.683-.193-1.32-.63-1.785C18.93 15.25 18.273 15 17.5 15zm0 1c.57 0 .914.16 1.14.4.227.24.36.602.36 1.1 0 .432-.19.776-.54 1.05-.353.272-.872.45-1.46.45h-1.423c.237-.4.422-.9.422-1.5 0-.39.13-.772.368-1.043.24-.27.583-.457 1.132-.457zM29.284 5.01c-.126.015-.233.048-.352.09-.238.08-.513.21-.838.374-.65.33-1.477.813-2.35 1.365-1.75 1.103-3.66 2.457-4.642 3.438-.935.934-1.616 1.784-1.936 2.637-.32.852-.186 1.777.478 2.44.665.665 1.59.8 2.442.48.853-.32 1.703-1.002 2.637-1.936.98-.983 2.335-2.893 3.44-4.64.552-.876 1.035-1.704 1.365-2.353.165-.324.293-.6.375-.838.04-.12.072-.226.086-.352.013-.126.047-.327-.167-.54-.214-.215-.413-.18-.54-.167zm-.647 1.444c-.307.603-.78 1.416-1.32 2.27-1.08 1.713-2.46 3.628-3.3 4.468-.888.887-1.678 1.48-2.283 1.707-.604.225-.954.177-1.383-.25-.427-.43-.475-.78-.25-1.384.228-.604.82-1.394 1.71-2.28.84-.84 2.754-2.22 4.466-3.3.856-.542 1.668-1.015 2.272-1.322.134-.036.13.022.09.09zM2.5 8h17c.277 0 .5.223.5.5s-.223.5-.5.5h-17c-.277 0-.5-.223-.5-.5s.223-.5.5-.5zM7 6.5c0 .276-.224.5-.5.5S6 6.776 6 6.5s.224-.5.5-.5.5.224.5.5zm-2 0c0 .276-.224.5-.5.5S4 6.776 4 6.5s.224-.5.5-.5.5.224.5.5zm-2 0c0 .276-.224.5-.5.5S2 6.776 2 6.5s.224-.5.5-.5.5.224.5.5zM1.5 4C.678 4 0 4.678 0 5.5v19c0 .822.678 1.5 1.5 1.5h25c.822 0 1.5-.678 1.5-1.5v-12c0-.668-1-.665-1 0v12c0 .286-.214.5-.5.5h-25c-.286 0-.5-.214-.5-.5v-19c0-.286.214-.5.5-.5h25c.665 0 .657-1 0-1z"></path></g>
                            </svg>
                        </ListItemIcon>
                        <ListItemText primary="Tema" secondary="Padrão de cores"/>
                    </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem disablePadding>
                    <ListItemButton onClick={() => setTela("papeis")}>
                        <ListItemIcon>
                            <Key />
                        </ListItemIcon>
                        <ListItemText primary="Papéis" secondary="Papeis e permissões"/>
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton onClick={() => setTela("redmine")}>
                        <ListItemIcon>
                            <img src='/redmine.ico' width='25px' height='25px'/>
                        </ListItemIcon>
                        <ListItemText primary="RedMine" secondary="Integração API"/>
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton onClick={() => setTela("chaves")}>
                        <ListItemIcon>
                            <EnhancedEncryption />
                        </ListItemIcon>
                        <ListItemText primary="Chaves" secondary="Chaves/Valor"/>
                    </ListItemButton>
                </ListItem>
            </List>
            
        </Box>
    );

    const desenhaTela=()=>{
        if( tela === 'home'){
            return (
                <Paper>
                    <Stack>
                        <Typography align='center' variant="h4" gutterBottom>Configurações do sistema</Typography>
                        <ul>
                            <li><Link component="button" variant="body2" onClick={() => setTela('theme')}>
                                Mudar paleta de cores Tema
                                </Link>
                            </li>
                            <li><Link component="button" variant="body2" onClick={() => setTela('papeis')}>
                                Papeis e permissões
                                </Link>
                            </li>
                            <li><Link component="button" variant="body2" onClick={() => setTela('chave')}>
                                Configurações de chaves seguras
                                </Link>
                            </li>
                            <li><Link component="button" variant="body2" onClick={() => setTela('redmine')}>
                                Integração como RedMine <img src='/redmine.ico' width='25px' height='25px'/>
                                </Link>
                            </li>
                        </ul>
                    </Stack>
                </Paper>
            )
        }
        if( tela === 'redmine'){
            return (
                <RedminePanel />
            )
        }
        if( tela === 'papeis'){
            return (
                <PapeisPanel />
            )
        }
        if( tela === 'chaves'){
            return (
                <ChavesPanel />
            )
        }
        if( tela === 'theme'){
            return (
                <ThemeSetting />
            )
        }
        return(
            <Typography color='red'>Tela não implementada: {tela}</Typography>
        )
    }
    return (
        <div style={{padding:"4px", marginTop: "5px"}}>
            {desenhaTela()}
            {showDraw &&
            <Drawer open={open} onClose={toggleDrawer(false)}>
                {DrawerList}
            </Drawer>
            }
        </div>
    );
}
